export const MenuFragment = /* GraphQL */ `
	fragment MenuFragment on Menu {
		_id
		created_at
		updated_at
		name
		description
		banner_img
	}
`;
